import React from 'react';
import { observer } from 'mobx-react';
import { Typography, IconButton, Button, Dialog, DialogContent, FormControlLabel, Checkbox, LinearProgress, Link } from '@material-ui/core';
import '../styles/Globales.scss';
import TextRipleyComponent from './utils/TextRipleyComponent';
import MaskedTextRipleyComponent from './utils/MaskedTextRipleyComponent';
import InfoIcon from '@material-ui/icons/InfoRounded';
import { ChevronRight, Close, EditOutlined } from '@material-ui/icons';
import * as rutUtils from './../utils/RutUtils';
import * as validador from './../utils/Utils';
import appStore from './../stores/AppStore';
import ViewConstants from './../utils/ViewConstants';
import AutoCompletar from './utils/AutoCompletar';
import PopUpMandatoComponent from './utils/PopupMandatoComponent.js';
import PopUpAutorizacionDatosPersonalesComponent from './utils/PopUpAutorizacionDatosPersonalesComponent';
import '../styles/PopUp.scss';
import popup from '../stores/PopupStore';

const component = observer(
  class IngresoDatosClienteComponent extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        txtCalle: '',
        txtNumero: '',
        txtResto: '',
        txtCelular: '',
        txtMail: '',
        errortxtRut: '',
        errortxtCelular: '',
        errortxtMail: '',
        msjOfertas: '',
        ofertas: false,
        rut: '',
        rutFormateado: '',
        msjRequerido: '',
        txtNumSerie: '',
        errortxtNumSerie: '',
        disabledVerificar: false,
        txtMailSugerido: '',
        chkAcepto: true,
        chkAutorizo: true,
        conCelular: [
          { numero: '000000000' },
          { numero: '111111111' },
          { numero: '222222222' },
          { numero: '333333333' },
          { numero: '444444444' },
          { numero: '555555555' },
          { numero: '666666666' },
          { numero: '777777777' },
          { numero: '888888888' },
          { numero: '999999999' },
          { numero: '012345678' },
          { numero: '123456789' },
          { numero: '987654321' },
        ],
        openDetalleCedula: false,
        errorCmbRegion: '',
        errorCmbComuna: '',
        errortxtCalle: '',
        errortxtNumero: '',
        errortxtResto: '',
        codComuna: 0,
        codRegion: 0,
        datosCliente: {},
        editable: true,
        disableFields: true,
      };
    }

    componentDidMount = () => {
      appStore.init();
    };

    //RUT
    onChangeRut = (event) => {
      let rut = rutUtils.unFormatRut(event.target.value);
      const reg = /^[0-9]{0,8}[0-9Kk]?$/;
      if (rut.length <= 9) {
        if (rut.match(reg)) {
          let estError;
          let msjError;
          this.setState({
            rut: event.target.value,
            rutFormateado: event.target.value,
          });
          if (rut.length < 5) {
            estError = true;
            msjError = 'Rut debe tener mas de 5 dígitos';
          } else {
            if (!rutUtils.validateRut(rut)) {
              estError = true;
              msjError = 'RUT inválido';
            } else {
              estError = false;
              msjError = '';
              this.setState({
                rutFormateado: rutUtils.formatRut(rut),
              });
            }
          }
          this.setState(
            {
              errorRut: estError,
              errortxtRut: msjError,
              rut: rut,
            },
            () => {
              this.serieCompleto(this.state.rut, this.state.txtNumSerie);
              this.activarBtn();
            }
          );
        }
      }
    };

    onFocusRut = (evt) => {
      const rut = rutUtils.unFormatRut(evt.target.value);
      this.setState({ rutFormateado: rut });
      if (this.state.rut === '') {
        this.setState({ errorRut: false, errortxtRut: '' });
      }
    };

    onBlurRut = (evt) => {
      const rut = rutUtils.unFormatRut(evt.target.value);
      const rutFormateado = rutUtils.formatRut(rut);
      this.setState({ rut: rut, rutFormateado: rutFormateado });
      this.serieCompleto(this.state.rut, this.state.txtNumSerie);
      if (this.state.rut === '') {
        this.setState({ errorRut: true, errortxtRut: 'Campo requerido rut' });
      }
    };

    //MAIL
    onChangeMail = (evt) => {
      this.setState({ txtMail: evt.target.value });
      let estError;
      let msjError;
      //valida formato del correo
      if (!validador.validarEmail(evt.target.value)) {
        estError = true;
        msjError = 'ejemplo@ejemplo.com';
      } else {
        estError = false;
        msjError = '';
      }

      this.setState(
        {
          errorMail: estError,
          errortxtMail: msjError,
        },
        () => {
          this.activarBtn();
        }
      );
    };

    onFocusMail = () => {
      if (this.state.txtMail === '') {
        this.setState({
          errorMail: false,
          errortxtMail: '',
        });
      }
    };

    onBlurMail = () => {
      this.setState({
        txtMail: validador.sinEspacios(this.state.txtMail),
      });

      if (this.state.txtMail === '') {
        this.setState({
          errorMail: true,
          errortxtMail: 'Campo requerido email',
        });
      }
      /*mailcheck.run({
        domains: domains,
        email: validador.sinEspacios(this.state.txtMail),
        suggested: (suggestion) => {
          this.setState({
            txtMailSugerido: suggestion.full,
          });
          this.sugerirMail(suggestion.full);
        },
      });*/
    };

    sugerirMail = (mail) => {
      popup.setPopupData({
        message: '¿Quisiste decir ' + mail + '?',
        btns: [
          {
            label: 'sí',
            action: this.cambiarMail,
            full: true,
            css: 'btnRipley',
          },
          {
            label: 'no',
            full: true,
            css: 'btnGris',
            close: true,
          },
        ],
      });
      popup.showPopup();
    };

    cambiarMail = () => {
      this.setState(
        {
          errortxtMail: '',
          errorMail: false,
          txtMail: this.state.txtMailSugerido,
        },
        () => {
          this.activarBtn();
        }
      );
      popup.hidePopup();
    };

    //CELULAR
    onChangeCelular = (evt) => {
      const digcel = evt.target.value;
      //Ingreso solo numeros
      const reg = /^[0-9]*$/;
      if (digcel.length <= 9) {
        if (digcel.match(reg)) {
          let estError = false;
          let msjError = '';
          this.setState({
            txtCelular: digcel,
          });

          //Largo del celular
          if (digcel.length < 9) {
            estError = true;
            msjError = 'Celular debe tener 9 dígitos';
          } else {
            //Celular con largo Correlativo
            if (validador.validarCelular(digcel)) {
              this.state.conCelular.forEach((cel) => {
                if (cel.numero === digcel) {
                  estError = true;
                  msjError = 'Celular inválido';
                }
              });
            }
          }
          this.setState(
            {
              errorCelular: estError,
              errortxtCelular: msjError,
            },
            () => {
              this.activarBtn();
            }
          );
        }
      }
    };

    onBlurCelular = (evt) => {
      //Ingresar numero de celular
      if (this.state.txtCelular === '') {
        this.setState({
          errorCelular: true,
          errortxtCelular: 'Campo requerido celular',
          celularValido: false,
        });
      }
    };

    onFocusCelular = (evt) => {
      //Ingresar numero de celular
      if (this.state.txtCelular === '') {
        this.setState({
          errorCelular: false,
          errortxtCelular: '',
        });
      }
    };

    onChangeNumSerie = (evt) => {
      let numSerie = evt.target.value;
      const reg = /^[a-zA-Z0-9]+$/;
      let limite = 9;
      if (numSerie) {
        numSerie = numSerie.toString().toUpperCase();
      }
      if (numSerie.length <= limite) {
        if (numSerie.match(reg) || numSerie === '') {
          this.setState(
            {
              txtNumSerie: numSerie,
              errorNumSerie: false,
              errortxtNumSerie: '',
            },
            () => {
              this.serieCompleto(this.state.rut, this.state.txtNumSerie);
              this.activarBtn();
            }
          );
        }
      }

      if (numSerie.length < 9) {
        this.setState({
          txtNumSerie: numSerie,
          errorNumSerie: true,
          errortxtNumSerie: 'Numero de serie debe tener 9 digitos',
        });
      }
    };

    serieCompleto = (rut, serie) => {
      if (rutUtils.validateRut(rut) && serie.length === 9) {
        this.buscarCliente();
      } else {
        this.resetFields();
      }
    };

    resetFields = () => {
      this.setState({ editable: true, disableFields: false, datosCliente: {} }, this.activarBtn);
    };

    activarBtn = () => {
      if (this.checkActiveButton()) {
        this.setState({ disabledVerificar: false });
      } else {
        this.setState({ disabledVerificar: true });
      }
    };

    checkActiveButton = () => {
      if (this.state.editable) {
        const err = [
          {
            errorTxt: this.state.errortxtCelular,
            txt: this.state.txtCelular,
          },{
            errorTxt: this.state.errortxtMail,
            txt: this.state.txtMail
          },{
            errorTxt: this.state.errortxtCalle,
            txt: this.state.txtCalle
          },{
            errorTxt: this.state.errortxtNumero,
            txt: this.state.txtNumero
          }
        ];

        if(err.some(item => item.errorTxt !== '' || item.txt === '')) {
          return false;
        } else {
          const codes = [this.state.codRegion, this.state.codComuna];
          if(codes.some(code => (code === undefined || code === null || code === 0))) {
            return false;
          }
        }
      }

      const errRut = [
        {
          errorTxt: this.state.errortxtRut,
          txt: this.state.rut,
        },{
          errorTxt: this.state.errortxtNumSerie,
          txt: this.state.txtNumSerie
        }
      ];

      if(errRut.some(item => item.errorTxt !== '' || item.txt === '')) {
        return false;
      }

      const chk = [this.state.chkAutorizo, this.state.chkAcepto];
      return !chk.some(c => c === false);
    };

    //CHECKS
    changeAcepto = (event) => {
      if (event.target.checked) {
        popup.showPopUpMandato();
      }
      this.setState(
        {
          chkAcepto: event.target.checked,
        },
        () => {
          this.activarBtn();
        }
      );
    };

    changeAutorizo = (event) => {
      this.setState(
        {
          chkAutorizo: event.target.checked,
        },
        () => {
          this.activarBtn();
        }
      );
    };
    //CALLE
    onChangeCalle = (evt) => {
      let errorCalle = true;
      let errortxtCalle = 'Calle Requerida';
      const value = evt.target.value;
      if (value) {
        errorCalle = false;
        errortxtCalle = '';
      }
      this.setState(
        {
          txtCalle: value,
          errorCalle,
          errortxtCalle,
        },
        () => {
          this.activarBtn();
        }
      );
    };

    onChangeNumero = (evt) => {
      const num = evt.target.value;
      const reg = /^[0-9]*$/;
      if (num) {
        if (num.match(reg)) {
          this.setState({ txtNumero: num, errorNumero: false, errortxtNumero: '' }, () => {
            this.activarBtn();
          });
        }
      } else {
        this.setState({ txtNumero: num, errorNumero: true, errortxtNumero: 'Numero requerido' }, () => {
          this.activarBtn();
        });
      }
    };

    onChangeResto = (evt) => {
      const value = evt.target.value;
      this.setState({ txtResto: value });
    };

    changeRegion = (valor) => {
      let errorCmbRegion = 'Region requerida';
      let errorRegion = true;
      if (valor) {
        errorRegion = false;
        errorCmbRegion = '';
      }
      this.setState(
        {
          codRegion: valor,
          errorRegion,
          errorCmbRegion,
        },
        () => {
          this.activarBtn();
        }
      );
      appStore.cargarComunas(valor);
    };

    changeComuna = (valor) => {
      let errorCmbComuna = 'Comuna requerida';
      let errorComuna = true;
      if (valor) {
        errorCmbComuna = '';
        errorComuna = false;
      }
      this.setState(
        {
          codComuna: valor,
          errorCmbComuna,
          errorComuna,
        },
        () => {
          this.activarBtn();
        }
      );
    };

    //VALIDACIONES
    validacion = () => {
      let valid = true;
      let msgValidacion = 'Debes completar todos los campos requeridos.';

      if (this.state.errorNumSerie === true) {
        valid = false;
      }

      if (this.state.txtNumSerie === '') {
        this.setState({
          errorNumSerie: true,
          errortxtNumSerie: 'Campo requerido Número de Serie',
        });
        valid = false;
      }

      if (this.state.rut === '') {
        this.setState({ errorRut: true, errortxtRut: 'Campo requerido rut' });
        valid = false;
      }

      if (this.state.errorRut === true) {
        valid = false;
      }

      if (!rutUtils.validateRut(this.state.rut)) {
        this.setState({ errorRut: true, errortxtRut: 'RUT inválido' });
        valid = false;
      }

      valid = this.validationEditable(valid);

      if (valid && this.state.chkAutorizo === false) {
        valid = false;
        msgValidacion = 'Debes aceptar términos y condiciones.';
      }

      if (!valid) {
        popup.setPopupData({
          title: '',
          message: msgValidacion,
          btns: [{ label: 'aceptar', close: true, full: true, css: 'btn-morado' }],
        });
        popup.showPopup();
      }

      return valid;
    };

    validationEditable = (validation) => {
      let valid = validation;
      if (this.state.editable) {
        if (this.state.errorMail === true) {
          valid = false;
        }

        const txt = [{
          inputText: true,
          field: this.state.txtMail,
          errorTxtName: 'errortxtMail',
          errorTxtValue: 'Campo requerido email',
          errorName: 'errorMail',
          erroValue: true
        },{
          inputText: true,
          field: this.state.txtCalle,
          errorTxtName: 'errortxtCalle',
          errorTxtValue:'Calle Requerida',
          errorName: 'errorCalle',
          erroValue: true
        },{
          inputText: true,
          field: this.state.txtNumero,
          errorTxtName: 'errortxtNumero',
          errorTxtValue:'Número Requerido',
          errorName: 'errorNumero',
          erroValue: true
        },{
          inputText: true,
          field: this.state.txtCelular,
          errorTxtName: 'errortxtCelular',
          errorTxtValue:'Campo requerido celular',
          errorName: 'errorCelular',
          erroValue: true
        },{
          inputText: false,
          field: this.state.codRegion,
          errorName: 'errorCmbRegion',
          errorValue: 'Región Requerida',
          erroValue: null,
          errorTxtValue: null
        },{
          inputText: false,
          field: this.state.codComuna,
          errorName: 'errorCmbComuna',
          errorValue: 'Comuna Requerida',
          erroValue: null,
          errorTxtValue: null
        }];

        txt.forEach((t) => {
          if(t.inputText && t.field === '') {
            this.setState({ [t.errorName]: t.erroValue, [t.errorTxtName]: t.errorTxtValue });
            valid = false;
          } else if (!t.inputText && (t.field === 0 || t.field === undefined || t.field === null)) {
            this.setState({ [t.errorName]: t.errorValue });
            valid = false;
          }
        });
      }
      return valid;
    }

    onClickComenzar = () => {
      appStore.generateDataLayer({ eventAction: 'step_1.1', eventLabel: 'portate_comenzar' });
      if (this.validacion()) {
        const rutSinDv = this.state.rut.substring(0, this.state.rut.length - 1);
        appStore.iniciarFlujo(
          rutSinDv,
          this.state.txtCelular,
          this.state.txtMail,
          this.state.txtNumSerie,
          this.state.codRegion,
          this.state.codComuna,
          this.state.txtCalle,
          this.state.txtNumero,
          this.state.txtResto,
          this.state.datosCliente.id
        );
      }
    };

    openDetalleCedula = () => {
      this.setState({ openDetalleCedula: true });
    };

    closeDetalleCedula = () => {
      this.setState({ openDetalleCedula: false });
    };

    handleChangeCombos = (nombreCombo, valor, glosa) => {
      if (nombreCombo === 'cmbRegiones') {
        this.changeRegion(valor);
      }

      if (nombreCombo === 'cmbComunas') {
        this.changeComuna(valor);
      }
    };

    buscarCliente = () => {
      if (this.state.rut && this.state.txtNumSerie && !this.state.errorRut && !this.state.errorNumSerie) {
        const rutSinDv = this.state.rut.substring(0, this.state.rut.length - 1);
        appStore.buscarCliente(rutSinDv, this.state.txtNumSerie, this.onResultBuscarCliente, this.onFailBuscarCliente);
      }
    };

    onFailBuscarCliente = () => {
      this.setState({ disableFields: false, datosCliente: {} });
    };

    onResultBuscarCliente = (result) => {
      if (result.idRegion && result.idComuna) {
        appStore.generateDataLayer({ eventAction: 'step_1', eventLabel: 'portate_numero_serie' });
        appStore.cargarComunas(result.idRegion, () => {
          let datosCliente = result;
          datosCliente.nombreRegion = appStore.findNombreRegion(result.idRegion);
          datosCliente.nombreComuna = appStore.findNombreComuna(result.idComuna);
          this.setState(
            {
              datosCliente,
              editable: false,
              disableFields: true,
            },
            this.activarBtn
          );
        });
      } else {
        this.onFailBuscarCliente();
      }
    };

    onModificarDatos = () => {
      this.setState({ editable: true, disableFields: false, datosCliente: {} }, this.activarBtn);
    };
    renderDatosNoEditables = () => {
      const celular = this.state.datosCliente.celular ? this.state.datosCliente.celular : '';
      const email = this.state.datosCliente.email ? this.state.datosCliente.email : '';
      const calle = this.state.datosCliente.calle ? this.state.datosCliente.calle : '';
      const numero = this.state.datosCliente.numero ? this.state.datosCliente.numero : '';
      const resto = this.state.datosCliente.resto ? this.state.datosCliente.resto : '';
      const nombreRegion = this.state.datosCliente.nombreRegion ? this.state.datosCliente.nombreRegion : '';
      const nombreComuna = this.state.datosCliente.nombreComuna ? this.state.datosCliente.nombreComuna : '';
      return (
        <div className="cajaFormulario">
          <Button className="editarDatos" tabIndex="-1" onClick={this.onModificarDatos}>
            <EditOutlined />
            modificar datos
          </Button>
          <div className="formulario">
            <div className="TextRipley">
              <TextRipleyComponent className="TextRipley" id="txtMail2" label="email" fullWidth={true} value={email} placeholder="ejemplo@ejemplo.com" />
            </div>
            <div className="TextRipley celular">
              <div className="numero">
                <Typography>(+56)</Typography>
              </div>
              <TextRipleyComponent className="TextRipley" id="txtCelular2" label="celular" fullWidth={true} value={celular} placeholder="912345678" />
            </div>
            <div className="TextRipley ">
              <TextRipleyComponent className="TextRipley" id="txtCalle2" label="calle" fullWidth={true} value={calle} />
            </div>
            <div className="camposDobles">
              <div className="TextRipley ">
                <TextRipleyComponent className="TextRipley" fullWidth={true} id="txtNumero2" label="número" value={numero} placeholder="123" />
              </div>
              <div className="TextRipley ">
                <TextRipleyComponent className="TextRipley" fullWidth={true} id="txtResto2" label="depto/ villa/ block" value={resto} />
              </div>
            </div>
            <div className="TextRipley autoCompletar">
              <TextRipleyComponent className="TextRipley" fullWidth={true} id="txtRegion2" label="Región" value={nombreRegion} />
            </div>
            <div className="TextRipley autoCompletar">
              <TextRipleyComponent className="TextRipley" fullWidth={true} id="txtComuna2" label="Comuna" value={nombreComuna} />
            </div>
          </div>
        </div>
      );
    };
    renderDatosEditables = () => {
      return (
        <div className="cajaFormulario">
          <div className="formulario">
            <div className="TextRipley">
              <TextRipleyComponent
                className="TextRipley"
                id="txtMail"
                label="email"
                fullWidth={true}
                value={this.state.txtMail}
                error={this.state.errorMail}
                errorText={this.state.errortxtMail}
                onChange={this.onChangeMail}
                onFocus={this.onFocusMail}
                onBlur={this.onBlurMail}
                placeholder="ejemplo@ejemplo.com"
              />
            </div>
            <div className="TextRipley celular">
              <div className="numero">
                <Typography>(+56)</Typography>
              </div>
              <TextRipleyComponent
                className="TextRipley"
                id="txtCelular"
                label="celular"
                fullWidth={true}
                value={this.state.txtCelular}
                error={this.state.errorCelular}
                errorText={this.state.errortxtCelular}
                onChange={this.onChangeCelular}
                onFocus={this.onFocusCelular}
                onBlur={this.onBlurCelular}
                placeholder="912345678"
              />
            </div>
            <div className="TextRipley ">
              <TextRipleyComponent
                className="TextRipley"
                id="txtCalle"
                label="calle"
                fullWidth={true}
                value={this.state.txtCalle}
                error={this.state.errorCalle}
                errorText={this.state.errortxtCalle}
                onChange={this.onChangeCalle}
              />
            </div>
            <div className="camposDobles">
              <div className="TextRipley ">
                <TextRipleyComponent
                  className="TextRipley"
                  fullWidth={true}
                  id="txtNumero"
                  label="número"
                  value={this.state.txtNumero}
                  error={this.state.errorNumero}
                  errorText={this.state.errortxtNumero}
                  onChange={this.onChangeNumero}
                  placeholder="123"
                />
              </div>
              <div className="TextRipley">
                <TextRipleyComponent
                  className="TextRipley"
                  fullWidth={true}
                  id="txtResto"
                  label="depto/ villa/ block"
                  value={this.state.txtResto}
                  error={this.state.errorResto}
                  errorText={this.state.errortxtResto}
                  onChange={this.onChangeResto}
                />
              </div>
            </div>
            <div className="TextRipley autoCompletar">
              <label className="labelSelect">región</label>
              <AutoCompletar
                id="cmbRegiones"
                options={appStore.regiones}
                placeholder="seleccione región"
                nomCombo="cmbRegiones"
                handleChange={this.handleChangeCombos}
                valor={this.state.codRegion}
                errorText={this.state.errorCmbRegion}
                onlyAZ={true}
              />
            </div>
            <div className="TextRipley autoCompletar">
              <label className="labelSelect">comuna</label>
              <AutoCompletar
                id="cmbComunas"
                options={appStore.comunas}
                placeholder="seleccione comuna"
                nomCombo="cmbComunas"
                handleChange={this.handleChangeCombos}
                valor={this.state.codComuna}
                errorText={this.state.errorCmbComuna}
                onlyAZ={true}
              />
            </div>
          </div>
        </div>
      );
    };

    renderDatosCliente = (editable) => {
      let result;
      if (editable) {
        result = this.renderDatosEditables();
      } else {
        result = this.renderDatosNoEditables();
      }
      return result;
    };

    abrirCondiciones = () => {
      popup.showPopUpMandato();
    };

    render() {
      return (
        <div className="contenedorPrincipal">
          <div className="paso">
            <Typography className="tituloBR">Pórtate a Banco Ripley</Typography>
          </div>

          <LinearProgress variant="determinate" color="secondary" value={appStore.navigationSection * (100 / ViewConstants.TOTAL_ETAPAS)} className="barraProgreso" />
          <Typography className="bajadaTitulo">Ingresa tus datos para iniciar una solicitud de portabilidad o para hacer seguimiento a una solicitud</Typography>
          <div className="TextInputs">
            <div className="TextRipley">
              <TextRipleyComponent
                className="TextRipley"
                id="txtRut"
                label="rut"
                fullWidth={true}
                error={this.state.errorRut}
                errorText={this.state.errortxtRut}
                value={this.state.rutFormateado}
                onChange={this.onChangeRut}
                onFocus={this.onFocusRut}
                onBlur={this.onBlurRut}
                placeholder="123123123"
              />
            </div>
            <div className="TextRipley cedula">
              <MaskedTextRipleyComponent
                className="TextRipley"
                id="txtNumSerie"
                label="nº de serie o documento"
                fullWidth={true}
                value={this.state.txtNumSerie}
                error={this.state.errorNumSerie}
                errorText={this.state.errortxtNumSerie}
                onChange={this.onChangeNumSerie}
                placeholder="110114663"
                disabled={this.state.disabledValidarCedula}
              />
              <div className="btnIconInfo">
                <IconButton color="primary" onClick={this.openDetalleCedula} tabIndex="-1">
                  <InfoIcon />
                </IconButton>
              </div>
            </div>
            {this.renderDatosCliente(this.state.editable)}
          </div>

          {/*<div className="aceptarCondiciones">
            <Typography>
              Acepto mandato para solicitar Certificado de Liquidación a
              Instituciones Financieras
            </Typography>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={this.state.chkAcepto}
                  onChange={this.changeAcepto}
                />
              }
            />
            </div>*/}
          <div className="aceptarCondiciones">
            <Typography>
              Acepto{' '}
              <Link onClick={this.abrirCondiciones} underline="always">
                términos y condiciones
              </Link>{' '}
              para realizar evaluación crediticia.
            </Typography>
            <FormControlLabel label="" control={<Checkbox color="primary" checked={this.state.chkAutorizo} onChange={this.changeAutorizo} />} />
          </div>
          <div className="botones">
            <Button color="primary" id="btnVerifica" variant="contained" fullWidth={true} onClick={this.onClickComenzar} disabled={this.state.disabledVerificar}>
              comenzar <ChevronRight />
            </Button>
          </div>
          <Dialog open={this.state.openDetalleCedula}>
            <DialogContent>
              <div className="cerrarBtnModal">
                <IconButton onClick={this.closeDetalleCedula}>
                  <Close />
                </IconButton>
              </div>
              <Typography className="tituloModalCarnet">Dónde encontrar el N° de serie o documento</Typography>
              <div className="imgModalCarnet">
                <img className="carnetImg" src={require('../images/carnet-front.png')} alt="carnetImg" />
                <img className="carnetImg" src={require('../images/carnet-back.png')} alt="carnetImg" />
              </div>
            </DialogContent>
            <div>
              <div className="franjaColores">
                <div className="rojo" />
                <div className="amarillo" />
                <div className="morado" />
              </div>
            </div>
          </Dialog>
          <PopUpMandatoComponent />
          <PopUpAutorizacionDatosPersonalesComponent />
        </div>
      );
    }
  }
);

const IngresoDatosClienteComponent = component;
export default IngresoDatosClienteComponent;
